import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Environment, Header } from '@aptsi-types';
import { EnvironmentService } from '../environment.service';
import { MatDialog } from '@angular/material/dialog';
import { KeycloakStateService } from 'src/app/core/service/utility.service';
import { DeleteDialogComponent } from 'src/app/shared/dialogs/delete-dialog/delete-dialog.component';

@Component({
  selector: 'app-environment-search',
  templateUrl: './environment-search.component.html',
  styleUrls: ['./environment-search.component.scss']
})
export class EnvironmentSearchComponent {
 totalPages = 0;
  totalPagesNormal = 0;
  totalPagesSearch = 0;

  itemsPerPage = 10;
  currentPage = 1;

  sessionId = this.keycloakStateService.getSessionId();
  userId = this.keycloakStateService.getUserId();
  transactionId = this.keycloakStateService.getTransactionId();
  isAdd: boolean = false;

  get paginatedData() {
    if (!this.isSearch) {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredData.slice(start, end);
    } else {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;

      return this.searchedData.slice(start, end);
    }
  }

  filteredData: Environment[] = [];
  searchedData: Environment[] = [];

  changePage(page: number) {
    this.currentPage = page;
    if (!this.isSearch) {
      this.totalPages = this.totalPagesNormal; // Ensure correct total pages
      this.fetchEnvironments();
    } else {
      this.totalPages = this.totalPagesSearch; // Ensure correct total pages
      this.fetchEnvironmentsSearch();
    }
  }

  headers: Header[] = [
    {
      name: "Environment Id",
      property: "id",
      showInDropdown: true,
      description: "Unique identifier for the environment", // Tooltip content
    },
    {
      name: "Environment Name",
      property: "environmentName",
      showInDropdown: true,
      description: "Name of the environment",
    },
    {
      name: "Description",
      property: "description",
      showInDropdown: false,
      description: "Description of the environment",
    },
    {
      name: "Last Updated",
      property: "updatedAt",
      showInDropdown: true,
      description: "Timestamp of the most recent update",
    },
  ];
  searchText: string = ""; // Initialize to an empty string
  filterByHeader: string = "all"; // Default to "all" to show all categories
  assetsources: Environment[] = [];
  nullver: number = 1;
  isSearch: boolean = false;


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private environmentService: EnvironmentService,
    private dialog: MatDialog,
    private keycloakStateService: KeycloakStateService
  ) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe((params) => {
      if (params["isAdd"] === "true") {
        this.isAdd = true;
      }
    });

    this.fetchEnvironments();

  }

  handleAction(event: { action: string; rowIndex: number; rowData: any }) {
    console.log(` Row Index: ${event.rowIndex}`, event.rowData);

    if (event.action === "update") {
      //this.updateRow(event.rowIndex, event.rowData);
      this.updateEnvironment(event.rowIndex);
    } else if (event.action === "delete") {
      this.deleteEnvironment(event.rowIndex);
    } 
  }

  buttonConfig = {
    update: true,
    delete: true,
    import: false,
    configure: false,
  };

  async fetchEnvironments() {
    try {
      const response = await this.environmentService
        .getEnvironments(this.currentPage - 1)
        .toPromise();
      //this.assetsources = response;
      this.filteredData = [...response];

      if (response.length > 0 && response[0].totalPages) {
        this.totalPagesNormal = response[0].totalPages;
        this.totalPages = this.totalPagesNormal; // Sync `totalPages` with `totalPagesNormal`
        this.currentPage = response[0].currentPage + 1;
      }
    } catch (error) {
      console.error("Error fetching asset sources:", error);
    }
  }

  async fetchEnvironmentsSearch() {
    try {
      const response = await this.environmentService
        .getEnvironmentsSearch(
          this.currentPage - 1,
          this.searchText,
          this.filterByHeader
        )
        .toPromise();
      this.searchedData = [...response];
      console.log(response);
      if (response.length > 0 && response[0].totalPages) {
        this.totalPagesSearch = response[0].totalPages;
        this.totalPages = this.totalPagesSearch; // Sync `totalPages` with `totalPagesSearch`
        this.currentPage = response[0].currentPage + 1;
      }
    } catch (error) {
      console.error("Error fetching assets:", error);
    }
  }

  resetSearchText(): void {
    this.searchText = "";
    this.isSearch = false; // Switch to normal mode
    this.currentPage = 1; // Reset to the first page of normal data
  }

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchText = input.value;
  }

   async searchEnvironments(): Promise<void> {
    try {
      if (this.searchText) {

        // Default value
        if (!this.filterByHeader) {
          this.filterByHeader = "all";
        }

        this.isSearch = true;

        await this.fetchEnvironmentsSearch();
        this.totalPages = this.totalPagesSearch;

        const selectedHeader = this.headers.find(
          (h) => h.property === this.filterByHeader && h.showInDropdown
        );

        if (this.filterByHeader === "all") {

          this.searchedData = this.searchedData.filter((rule) =>
            this.headers.some((header) => {
              const value = rule[header.property];

              return value
                ?.toString()
                .toLowerCase()
                .includes(this.searchText.toLowerCase());
            })
          );

        } else if (selectedHeader) {

          this.searchedData = this.searchedData.filter((rule) => {
            const value = rule[selectedHeader.property];

            return value
              ?.toString()
              .toLowerCase()
              .includes(this.searchText.toLowerCase());
          });

          this.searchedData.sort((a, b) =>
            a[selectedHeader.property]
              ?.toString()
              .localeCompare(b[selectedHeader.property]?.toString())
          );

        } else {
          this.filteredData = [];
        }

      } else {

        this.isSearch = false;
        await this.fetchEnvironments();

      }
    } catch (error) {
      console.error("Error during search:", error);
    }
  }

  addEnvironment(){
    this.router.navigate(["secure-zone/environment/create"]);
  }


  async deleteEnvironment(index: number) {
     try {
            const dialogRef = this.dialog.open(DeleteDialogComponent, {
              data: {
                title: "Are you sure?",
                message: "Do you really want to delete this Environment?",
                isConfirm: false,
              },
            });
      
            const result = await dialogRef.afterClosed().toPromise();
            if (!result) return;
      
            const environmentId = this.isSearch
              ? this.searchedData[index].id
              : this.filteredData[index].id;
            if (!environmentId) return;
            
            await this.environmentService.deleteEnvironment(environmentId).toPromise();
      
            this.isSearch ? this.fetchEnvironmentsSearch() : this.fetchEnvironments();
      
            this.dialog.open(DeleteDialogComponent, {
              data: {
                title: "Success",
                message: "The Environment has been deleted successfully.",
                isConfirm: true,
              },
            });
          } catch (error) {
            console.error("Error deleting Environment:", error);
          }
  }



 





  async updateEnvironment(index: number) {
      this.router.navigate(["secure-zone/environment/update", this.isSearch ? this.searchedData[index].id : this.filteredData[index].id])
       
  }





  back() {
    try {
      if (this.isSearch) {
        this.isSearch = false;
        this.totalPages = this.totalPagesNormal; // Restore total pages for normal pagination
        this.currentPage = 1;
        this.fetchEnvironments();
      } else {
        this.router.navigate(["secure-zone"]);
      }
    } catch (error) { }
  }
}
